<app-header-one [sticky]="true" *ngIf="url != '/pages/comingsoon'"></app-header-one>
<router-outlet></router-outlet>
<app-footer-one *ngIf="url != '/pages/comingsoon'"></app-footer-one>
